import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './index.styl'

const InvestorService = ({ pageData, activeCat }) => {
  const { t } =  useTranslation()
  return (
    <div className="investor-service investor__main">
      <h2 className="investor__title">{t(`nav_${activeCat}`)}</h2>
      <div className="investor__content">
        <h3 className="investor__sub-title">{t('investorService.stockCode', { code: pageData[0].stock_symbol })}</h3>
        <h3 className="investor__sub-title">{t('investorService.spokesman')}</h3>
        <div className="investor-service__paragraph" dangerouslySetInnerHTML={{ __html: pageData[0].spokesman.split(/[\n\r|\n|\r\n]/).join('<br>')}}/>
        <h3 className="investor__sub-title">{t('investorService.acting_spokesperson')}</h3>
        <div className="investor-service__paragraph" dangerouslySetInnerHTML={{ __html: pageData[0].acting_spokesperson.split(/[\n\r|\n|\r\n]/).join('<br>')}}/>
        <h3 className="investor__sub-title">{t('investorService.stock_agency')}</h3>
        <div className="investor-service__paragraph" dangerouslySetInnerHTML={{ __html: pageData[0].stock_agency.split(/[\n\r|\n|\r\n]/).join('<br>')}}/>
      </div>
    </div>
  )
}

InvestorService.propTypes = {}

export default InvestorService
